import { TFunction } from 'i18next'

import { MenuNavItem } from '../../Navigation/elements/MenuActions'
import { SearchResultItem } from '../types/searchResultItem'
import { getIconName } from './getIconName'

export const getSearchItemsFromFastMenu = (fastMenuItems: MenuNavItem[], t: TFunction): SearchResultItem[] => {
  const items: SearchResultItem[] = []

  for (const fastMenuItem of fastMenuItems) {
    const { id, children, value, to } = fastMenuItem

    items.push({
      id,
      text: `${t('global_search.new')}: ${children}`,
      icon: getIconName(fastMenuItem),
      routeTo: value,
      category: 'menu',
      to,
    })
  }

  return items
}
